<div class="flex flex-col gap-3">
  <div class="flex flex-wrap items-center gap-x-3 gap-y-2.5">
    <!-- Período -->
    <div class="flex max-w-full overflow-x-auto rounded-xl bg-gray-100 p-1 dark:bg-gray-800" role="group" aria-label="Período del reporte">
      @for (preset of presets; track preset.value) {
        <button type="button"
          (click)="selectPreset(preset.value)"
          [attr.aria-pressed]="activePreset() === preset.value"
          class="shrink-0 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand-500"
          [class]="activePreset() === preset.value
            ? 'bg-white text-gray-900 shadow-theme-xs dark:bg-gray-950 dark:text-white'
            : 'text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'">
          {{ preset.label }}
        </button>
      }
    </div>

    <!-- Rango exacto -->
    <div class="flex items-center gap-1.5 rounded-xl border px-2 py-1"
      [class]="activePreset() === 'custom'
        ? 'border-brand-300 bg-brand-25 dark:border-brand-500/40 dark:bg-brand-500/10'
        : 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900'">
      <label class="sr-only" for="rpt-from">Desde</label>
      <input id="rpt-from" type="date" class="date-picker-visible h-8 w-[8.5rem] bg-transparent px-1 text-sm text-gray-700 focus:outline-none dark:text-gray-200"
        [(ngModel)]="customStartDate" (change)="applyCustomRange()" [max]="customEndDate" />
      <span class="text-sm text-gray-400" aria-hidden="true">–</span>
      <label class="sr-only" for="rpt-to">Hasta</label>
      <input id="rpt-to" type="date" class="date-picker-visible h-8 w-[8.5rem] bg-transparent px-1 text-sm text-gray-700 focus:outline-none dark:text-gray-200"
        [(ngModel)]="customEndDate" (change)="applyCustomRange()" [min]="customStartDate" />
    </div>

    <div class="ml-auto flex items-center gap-2">
      <button type="button" (click)="toggleFilters()"
        [attr.aria-expanded]="showFilters()"
        aria-controls="rpt-filter-panel"
        class="inline-flex h-10 items-center gap-2 rounded-xl border px-3.5 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand-500"
        [class]="showFilters() || activeFilterCount
          ? 'border-brand-300 bg-brand-25 text-brand-700 dark:border-brand-500/40 dark:bg-brand-500/10 dark:text-brand-300'
          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-800'">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M7 12h10m-7 6h4" />
        </svg>
        Filtrar
        @if (activeFilterCount) {
          <span class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-500 px-1.5 text-xs font-semibold text-white">{{ activeFilterCount }}</span>
        }
      </button>
      <ng-content />
    </div>
  </div>

  @if (rangeError()) {
    <p class="text-sm text-error-600 dark:text-error-400" role="alert">{{ rangeError() }}</p>
  }

  @if (showFilters()) {
    <div id="rpt-filter-panel" class="grid grid-cols-1 gap-3 rounded-2xl border border-gray-200 bg-white p-4 sm:grid-cols-2 lg:grid-cols-4 dark:border-gray-800 dark:bg-gray-900">
      @if (canFilterProfessional) {
        <div>
          <label for="filter-professional" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Profesional</label>
          <select id="filter-professional" [(ngModel)]="selectedProfessionalId" (ngModelChange)="onFilterChange()"
            class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-500/15 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
            <option value="">Todo el equipo</option>
            @for (prof of professionals; track prof.id) {
              <option [value]="prof.id">{{ prof.name }}</option>
            }
          </select>
        </div>
      }
      <div>
        <label for="filter-service" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Servicio</label>
        <select id="filter-service" [(ngModel)]="selectedServiceId" (ngModelChange)="onFilterChange()"
          class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-500/15 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
          <option value="">Todos los servicios</option>
          @for (svc of services; track svc.id) {
            <option [value]="svc.id">{{ svc.name }}</option>
          }
        </select>
      </div>
      <div>
        <label for="filter-status" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Estado de la cita</label>
        <select id="filter-status" [(ngModel)]="selectedStatusCode" (ngModelChange)="onFilterChange()"
          class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-500/15 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
          <option value="">Todos los estados</option>
          @for (status of statusOptions; track status.value) {
            <option [value]="status.value">{{ status.label }}</option>
          }
        </select>
      </div>
      <div>
        <label for="filter-payment" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Método de pago</label>
        <select id="filter-payment" [(ngModel)]="selectedPaymentMethod" (ngModelChange)="onFilterChange()"
          class="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-3 focus:ring-brand-500/15 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
          <option value="">Todos los métodos</option>
          @for (method of paymentMethodOptions; track method.value) {
            <option [value]="method.value">{{ method.label }}</option>
          }
        </select>
        <p class="mt-1.5 text-xs text-gray-500 dark:text-gray-400">Solo afecta los ingresos cobrados.</p>
      </div>
    </div>
  }

  @if (activeFilterCount) {
    <div class="flex flex-wrap items-center gap-2" aria-label="Filtros activos">
      @for (f of activeFilters(); track f.key) {
        <span class="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white py-1 pl-3 pr-1 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">{{ f.label }}:</span> {{ f.value }}
          <button type="button" (click)="removeFilter(f.key)"
            class="inline-flex h-6 w-6 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-2 focus-visible:outline-brand-500 dark:hover:bg-gray-800 dark:hover:text-gray-200"
            [attr.aria-label]="'Quitar filtro ' + f.label">
            <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" d="M6 18 18 6M6 6l12 12" /></svg>
          </button>
        </span>
      }
      <button type="button" (click)="clearFilters()" class="rounded-lg px-2 py-1 text-sm font-medium text-brand-600 hover:underline dark:text-brand-400">Quitar filtros</button>
    </div>
  }
</div>
